import React from "react";
import PropTypes from "prop-types";
import {
  ListItem as MuiListItem,
  ListItemIcon as MuiListItemIcon
} from "@material-ui/core";
import styled from "styled-components";
import MuiBadge from "@material-ui/core/Badge";

const Container = styled(MuiListItem).withConfig({
  shouldForwardProp: prop => !["badgeNumber", "badgeDot"].includes(prop)
})`
  position: relative;
  height: 70px;
  box-sizing: border-box;
  background-color: #fff;
  border-bottom: solid 1px #f2f2f2;
  align-items: center;
`;

const ListItemIcon = styled(MuiListItemIcon)`
  color: ${({ theme }) => theme.color.primary.dark};
  min-width: 52px;
  svg {
    width: 1.2em;
    height: 1.2em;
  }
`;

const ListItemText = styled.span`
  color: #7e7e7e;
  font-size: 16px;
  font-weight: normal;
  line-height: 1.25;
  letter-spacing: normal;
  flex: 1;
  min-width: 0;
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
`;

/** Ancora para o MuiBadge (exige filho); mantém o número junto ao rótulo do menu. */
const BadgeAnchor = styled.span`
  display: inline-flex;
  width: 8px;
  height: 8px;
  flex-shrink: 0;
`;

const Badge = styled(MuiBadge)`
  flex-shrink: 0;
`;

const ListItem = props => {
  const { button, icon, children, badgeNumber, badgeDot } = props;

  return (
    <Container button={button} {...props}>
      {icon && <ListItemIcon>{icon}</ListItemIcon>}
      <ListItemText>
        <span>{children}</span>
        {!!badgeNumber && (
          <Badge
            badgeContent={badgeDot ? undefined : badgeNumber}
            variant={badgeDot ? "dot" : "standard"}
            color="error"
          >
            <BadgeAnchor aria-hidden />
          </Badge>
        )}
      </ListItemText>
    </Container>
  );
};

ListItem.propTypes = {
  ...MuiListItem.propTypes,
  icon: PropTypes.node,
  button: PropTypes.bool,
  badgeNumber: PropTypes.number,
  badgeDot: PropTypes.bool
};

ListItem.defaultProps = {
  icon: null,
  button: true,
  badgeNumber: 0,
  badgeDot: false
};

export default ListItem;
